query availablePhoneNumbers ($areaCode: String!, $teamId: ID!) {
  availablePhoneNumbers(areaCode: $areaCode, teamId: $teamId) {
    number
    formattedNumber
    city
    state
    vendor
  }
}
